import { render, staticRenderFns } from "./ChildPreview.vue?vue&type=template&id=64e3c3a2&lang=pug"
import script from "./ChildPreview.vue?vue&type=script&lang=js"
export * from "./ChildPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports